/**
 * 搜索
 */
import React, {Component} from "react";
import {Input, Icon} from "antd";

export default class CmSearchInput extends Component {
    render() {
        const {
            placeholder = "请输入",
            onSearch,
            searchValue,
            onSearchValueChange
        } = this.props;
        return (
            <div style={{display: "inline-block"}}>
                <Input
                    placeholder={placeholder}
                    addonAfter={<Icon style={{cursor: "pointer"}} onClick={e => onSearch()} type="search"/>}
                    value={searchValue}
                    onChange={e => onSearchValueChange(e.target.value)}
                    onPressEnter={() => onSearch()}
                    allowClear={true}
                />
            </div>
        );
    }
}
